module.exports = __webpack_public_path__ + "static/media/exam creation.85dac3aa.svg";